import DirectPurchaseModal from './DirectPurchaseModal';

export default DirectPurchaseModal;
